export default __webpack_public_path__ + "static/media/Smoked.7f03eb6e.jpg";